<template>
    <el-row>
        <table-template :queryParams="queryParams" actionUrl="/lcwpInsurance/findInsuranceOrder.action"
                        ref="insuranceOrderTable">
            <template slot="search">
                <el-date-picker
                        style="margin-left:10px;"
                        v-model="queryParams.startEndTime"
                        @change="onDateTimeChange"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
                <el-input v-model="queryParams.keyword" style="margin-left:10px;width:230px;" placeholder="单号/姓名/电话"></el-input>
                <el-button style="margin-left:10px;" type="primary" @click="$refs['insuranceOrderTable'].search()">搜索</el-button>
                <el-button  @click="$router.push('saveInsuranceOrder')">新增</el-button>
            </template>
            <template slot="item">
                <el-table-column
                        label="保单号"
                        prop="number">
                </el-table-column>
                <el-table-column
                        label="姓名"
                        prop="insuredName">
                </el-table-column>
                <el-table-column
                        label="账号"
                        prop="insuredPhone">
                </el-table-column>
                <el-table-column
                        label="保险公司"
                        prop="companyName">
                </el-table-column>
                <el-table-column
                        label="来源渠道"
                        prop="channelName">
                </el-table-column>
                <el-table-column
                        label="保险金额(元)"
                        prop="costs">
                </el-table-column>
                <el-table-column
                        label="绿豆奖励(个)"
                        prop="maxCount">
                </el-table-column>
                <el-table-column
                        label="状态"
                        prop="status">
                    <template scope="scope">
              <span style="color:#fcb205" v-if="scope.row.status == 1">
                         {{ scope.row.status| authStatusFilter }}
                  </span>
                        <span style="color:green" v-if="scope.row.status == 2 ">
                         {{ scope.row.status| authStatusFilter }}
                  </span>
                        <span style="color:red" v-if="scope.row.status == 3 ">
                         {{ scope.row.status| authStatusFilter }}
                  </span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="创建时间"
                        prop="createTime">
                    <template scope="scope">
                        {{scope.row.createTime | dateTimeFormat}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="操作">
                    <template scope="scope">
                        <el-button type="text" @click="$router.push('saveInsuranceOrder/'+scope.row.id)">修改</el-button>
                        <el-button @click="showAuthStatus(scope.row.id)" type="text">审核</el-button>
                    </template>
                </el-table-column>
            </template>
        </table-template>
        <el-dialog :visible.sync="dialogAuthStatusFormVisible" label-width="80px" title="您正在进行信息审核！"
                   width="40%">

            <el-form :model="dialogAuthStatusForm" label-position="left" ref="dialogAuthStatusForm">
                <el-form-item label="审核">
                    <el-radio-group @change="changeStatusInfo()"   v-model="dialogAuthStatusForm.authStatus">
                        <el-radio :label="2">通过</el-radio>
                        <el-radio  :label="3">不通过</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div class="dialog-footer" slot="footer">
                <el-button @click="authStatus()" type="primary">确认无误</el-button>
            </div>
        </el-dialog>
    </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import insuranceModel from '@/framework/models/insuranceModel'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'insuranceOrder',
  data: function () {
    return {
      queryParams: {},
      dialogAuthStatusFormVisible: false,
      dialogAuthStatusForm: {
        isSend: false,
        authStatus: 2,
        remark: null
      }
    }
  },
  methods: {
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.$refs.insuranceOrderTable.search()
    },
    showAuthStatus: function (id) {
      this.dialogAuthStatusFormVisible = true
      this.dialogAuthStatusForm.id = id
      this.dialogAuthStatusForm.sendInfo = null
    },
    authStatus: function () {
      let that = this
      let param = { id: this.dialogAuthStatusForm.id, status: this.dialogAuthStatusForm.authStatus }
      let listener = {
        success: function (dataInfo) {
          that.dialogAuthStatusFormVisible = false
          that.$refs.insuranceOrderTable.search()
        }
      }
      insuranceModel.authInsuranceOrder(that, param, listener)
    }
  },
  filters: {
    authStatusFilter (value) {
      // 状态:1-待审核2-已通过 3-已驳回
      let filterValue = '状态不明确'
      switch (value) {
        case 1:
          filterValue = '待审核'
          break
        case 2:
          filterValue = '已通过'
          break
        case 3:
          filterValue = '已驳回'
          break
      }
      return filterValue
    }
  }
}
</script>

<style scoped>

</style>
